module.exports = __webpack_public_path__ + "static/media/portfolio1 (23).33daf86d.jpeg";